package com.dotpx.ambient

enum class AmbiencePlaybackPhase {
    Stopped,
    Playing,
    Morphing,
    Paused,
    Interrupted,
}

data class AmbiencePlaybackSnapshot(
    val phase: AmbiencePlaybackPhase = AmbiencePlaybackPhase.Stopped,
    val scene: AmbienceScene? = null,
    val seed: ULong? = null,
    val nextScene: AmbienceScene? = null,
    val secondsUntilAdvance: Int? = null,
    val errorMessage: String? = null,
    val matchesPresetCombination: Boolean = false,
)
